function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 28 27"
}, props), React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.105 7.553L13.766 0l8.065 7.584-1.692 1.8-5.169-4.861v14.189H12.5V4.382L6.728 9.415 5.105 7.553zM2.47 13.03v11.265H25V13.03h2.47v13.735H0V13.03h2.47z",
  fill: "#354147"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h27.47v26.764H0z"
})))));